<template>
  <v-container
    fluid
    class="pa-4"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <organizations-list
          :selected-id="selectedOrg ? selectedOrg.id : null"
          @select="selectOrganization"
        />
      </v-col>

      <v-col
        cols="12"
      >
        <organization-panel :org="selectedOrg" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import OrganizationsList from './components/clinicOne/OrganizationsList.vue'
  import OrganizationPanel from './components/clinicOne/OrganizationPanel.vue'

  export default {
    name: 'ClinicOneOrganizations',

    components: {
      OrganizationsList,
      OrganizationPanel,
    },

    data: () => ({
      selectedOrg: null,
    }),

    methods: {
      selectOrganization (org) {
        this.selectedOrg = org
      },
    },
  }
</script>
